<template>
    <div class="my-style">
    </div>
</template>
<script>
export default {
    name: "mystyle",
    props: {
        datas: Object,
    },
    data() {
        return {
        }
    },
    created() {
    },
    watch: {
        datas: {
            handler(newVal, oldVal) {
                console.log('MyStyle组件props datas 变化了', newVal, oldVal)
            },
            deep: true
        }
    },
    methods: {
        // 处理props datas 变化
        handleDatasChange(newVal, oldVal) {
            console.log('MyStyle组件props datas 变化了', newVal, oldVal)
        }
    }
}

</script>
<style scoped lang="scss">
.my-style {
    height: 100%;
}
</style>